import { render, staticRenderFns } from "./questionType6.vue?vue&type=template&id=19ed988c&scoped=true"
import script from "./questionType6.vue?vue&type=script&lang=js"
export * from "./questionType6.vue?vue&type=script&lang=js"
import style0 from "./questionType6.vue?vue&type=style&index=0&id=19ed988c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ed988c",
  null
  
)

export default component.exports